import { css } from "@emotion/css";
import { ExternalLink, PopoverBasicHelp, LegacyDataTable, LegacyDataTableHeader, LegacyDataTableRow, LegacyDataTableHeaderColumn, LegacyDataTableBody, LegacyDataTableRowColumn } from "@octopusdeploy/design-system-components";
import { borderRadius, fontSize, fontWeight, letterSpacing, lineHeight, space, themeTokens } from "@octopusdeploy/design-system-tokens";
export default function KubernetesDeploymentTargetsPopover() {
    return (<PopoverBasicHelp placement="bottom-start" width="extra-wide" link1={<ExternalLink href="k8sTargetComparison" size="medium">
                    Read full comparison
                </ExternalLink>} description={<div>
                    <div className={styles.helpPopoverDescription}>These are some of the key differences between the Kubernetes Agent and the Kubernetes API:</div>
                    <div className={styles.helpPopoverTableContainer}>
                        <LegacyDataTable>
                            <LegacyDataTableHeader>
                                <LegacyDataTableRow className={styles.helpPopoverTableHeaderRow}>
                                    <LegacyDataTableHeaderColumn></LegacyDataTableHeaderColumn>
                                    <LegacyDataTableHeaderColumn>Kubernetes Agent</LegacyDataTableHeaderColumn>
                                    <LegacyDataTableHeaderColumn>Kubernetes API</LegacyDataTableHeaderColumn>
                                </LegacyDataTableRow>
                            </LegacyDataTableHeader>
                            <LegacyDataTableBody className={styles.helpPopoverTableBody}>
                                <LegacyDataTableRow>
                                    <LegacyDataTableRowColumn className={styles.helpPopoverTableHeaderRow}>Connection method</LegacyDataTableRowColumn>
                                    <LegacyDataTableRowColumn className={styles.helpPopoverTableData}>Polling agent in cluster</LegacyDataTableRowColumn>
                                    <LegacyDataTableRowColumn className={styles.helpPopoverTableData}>Direct API communication</LegacyDataTableRowColumn>
                                </LegacyDataTableRow>
                                <LegacyDataTableRow>
                                    <LegacyDataTableRowColumn className={styles.helpPopoverTableHeaderRow}>Setup complexity</LegacyDataTableRowColumn>
                                    <LegacyDataTableRowColumn className={styles.helpPopoverTableData}>Generally simpler</LegacyDataTableRowColumn>
                                    <LegacyDataTableRowColumn className={styles.helpPopoverTableData}>Requires more setup</LegacyDataTableRowColumn>
                                </LegacyDataTableRow>
                                <LegacyDataTableRow>
                                    <LegacyDataTableRowColumn className={styles.helpPopoverTableHeaderRow}>Security</LegacyDataTableRowColumn>
                                    <LegacyDataTableRowColumn className={styles.helpPopoverTableData}>
                                        <div>No need to configure firewall</div>
                                        <div>No need to provide external access to cluster</div>
                                    </LegacyDataTableRowColumn>
                                    <LegacyDataTableRowColumn className={styles.helpPopoverTableData}>Depends on the cluster configuration</LegacyDataTableRowColumn>
                                </LegacyDataTableRow>
                            </LegacyDataTableBody>
                        </LegacyDataTable>
                    </div>
                </div>}/>);
}
const styles = {
    helpPopoverDescription: css({
        fontSize: fontSize.medium,
        color: themeTokens.color.text.primary,
        fontWeight: fontWeight[400],
        lineHeight: lineHeight.xSmall,
        letterSpacing: letterSpacing.wide,
        marginBottom: space[16],
    }),
    helpPopoverTableContainer: css({
        border: `1px solid ${themeTokens.color.border.primary}`,
        borderRadius: borderRadius.large,
    }),
    helpPopoverTableHeaderRow: css({
        "&, & th": {
            fontSize: fontSize.xSmall,
            color: themeTokens.color.text.primary,
            fontWeight: 600,
            lineHeight: lineHeight.xSmall,
            letterSpacing: letterSpacing.wide,
            paddingTop: space[4],
            paddingBottom: space[4],
        },
        "& th, & th:hover": {
            backgroundColor: themeTokens.color.background.secondary.default,
        },
        "& th:first-child": {
            borderTopLeftRadius: borderRadius["large"],
        },
        "& th:last-child": {
            borderTopRightRadius: borderRadius["large"],
        },
    }),
    helpPopoverTableBody: css({
        "& tr td": {
            paddingTop: space[6],
            paddingBottom: space[6],
            verticalAlign: "middle",
        },
    }),
    helpPopoverTableData: css({
        fontSize: fontSize.xSmall,
        color: themeTokens.color.text.primary,
        fontWeight: fontWeight[400],
        lineHeight: lineHeight.xSmall,
        letterSpacing: letterSpacing.wide,
    }),
};
